
import React from 'react';
import { Button } from '@/components/ui/button';
import { Users, ChevronDown, Crown } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import ChatGroupMembers from './ChatGroupMembers';
import MentionNavigator from './MentionNavigator';

interface ChatHeaderProps {
  selectedGroup: any;
  user: any;
  isCreator: boolean;
  chatType: 'open' | 'read_only';
  isMobile?: boolean;
  messages?: any[];
  onJumpToMention?: (messageId: string) => void;
}

const ChatHeader = ({ 
  selectedGroup, 
  user, 
  isCreator, 
  chatType, 
  isMobile = false,
  messages = [],
  onJumpToMention
}: ChatHeaderProps) => {
  if (!selectedGroup) {
    return null;
  }
  
  return (
    <div className="p-4 flex items-center justify-between">
      <div className="flex items-center gap-4">
        {/* Group Members Dropdown */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button 
              variant="outline" 
              size="sm" 
              className="bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600 hover:text-white"
            >
              <Users className="h-4 w-4 mr-2" />
              {selectedGroup.chat_name}
              <ChevronDown className="h-4 w-4 ml-2" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent 
            className="w-80 bg-gray-800 border-gray-700 text-white max-h-96 overflow-y-auto z-50"
            align="start"
          >
            <div className="p-0">
              <ChatGroupMembers
                chatGroupId={selectedGroup.chat_id}
                canManageMembers={true}
                currentUserId={user?.id}
                isCreator={isCreator}
                chatType={chatType}
              />
            </div>
          </DropdownMenuContent>
        </DropdownMenu>

        {/* Creator indicator */}
        {isCreator && (
          <div className="flex items-center gap-1 px-2 py-1 bg-yellow-600/20 text-yellow-400 rounded text-xs">
            <Crown className="h-3 w-3" />
            <span>Group Creator</span>
          </div>
        )}
      </div>

      {/* Mention Navigator */}
      {onJumpToMention && (
        <div className="flex items-center gap-2">
          <MentionNavigator
            messages={messages}
            currentUsername={user?.username}
            onJumpToMention={onJumpToMention}
            isMobile={isMobile}
          />
        </div>
      )}
    </div>
  );
};

export default ChatHeader;
